import React, { useRef, useState } from "react";
import PageHeading from "../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";
import balanceHistoryServices from "../services/BalanceHistory";
import DCard from "../components/DCard";
import DSpinner from "../components/DSpinner";
import Table from "../components/Table";
import DButton from "../components/DButton";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

const ColumnsSearch = [
  { key: "id", value: "الآيدي" },
  { key: "type", value: "النوع" },
  { key: "user_name", value: "اسم الزبون" },
  { key: "date", value: "التاريخ" },
  { key: "user_username", value: "اسم المستخدم" },
];
const columns = [
  {
    Header: "معرف العملية",
    accessor: "id",
  },
  {
    Header: "الاسم",
    accessor: "name",
  },
  {
    Header: "اسم المستخدم",
    accessor: "username",
  },
  {
    Header: " الرصيد قبل الطلب",
    accessor: "balance_before",
  },
  {
    Header: "الرصيد بعدالطلب",
    accessor: "balance_after",
  },

  {
    Header: "تاريخ العملية",
    accessor: "created_at",
  },
  {
    Header: "العملية",
    accessor: "action",
  },
];
const BalanceHistory = ({ title }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const searchRef = useRef();
  const selectRef = useRef();
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get("id") || "");
  const [searchParam, setSearchParam] = useState("id");
  const queryClient = useQueryClient();
  const handleSelectChange = () => {
    setSearchParam(selectRef.current.value);
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
      setSearchQuery("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault(false);
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
      setSearchQuery("");
    }
    queryClient.refetchQueries("getUsers");
  };

  const { data, isLoading, error } = useQuery(
    ["getAllBalance", currentPage, searchParam, searchQuery],
    () =>
      balanceHistoryServices.getAllBalanceWithSearch(
        currentPage + 1,
        searchParam,
        searchQuery
      )
  );
  const formattedData = (data) => {
    if (data.length > 0) {
      return data.map((d) => ({
        ...d,
        username: d.user.username,
        name: d.user.name,
        action: d.balance_before > d.balance_after ? "سحب" : "شحن",
        created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
        balance_after: +d.balance_after.toFixed(6),
        balance_before: +d.balance_before.toFixed(6),
      }));
    }

    return [];
  };
  const actionSorrundWithButton = (cell) => {
    return (
      <DButton
        className={"text-white min-w-[100px] rounded-[50px_!important]"}
        bgColor={cell.value === "شحن" ? "success" : "danger"}
      >
        {cell.render("Cell")}
      </DButton>
    );
  };
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DCard className={isLoading ? "min-h-[400px] relative" : ""}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <>
            <div>
              <form
                className="flex  max-lg:justify-center   flex-wrap gap-4 "
                onSubmit={handleSubmit}
              >
                <input
                  type="text"
                  ref={searchRef}
                  className="  px-[10px] relative max-lg:py-1 max-lg:w-full  border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
                  placeholder="البحث عن  ..."
                />
                <select
                  className=" px-[10px] relative  text-gray-700   max-lg:w-full border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
                  value={searchParam}
                  ref={selectRef}
                  onChange={handleSelectChange}
                >
                  {ColumnsSearch.map((d, index) => (
                    <option className="" key={index} value={d.key}>
                      {d.value}
                    </option>
                  ))}
                </select>
                <DButton
                  bgColor="success"
                  className=" px-4 max-lg:mb-2  max-lg:w-full     text-white"
                  type="submit"
                >
                  {" "}
                  بحث
                </DButton>
              </form>
            </div>
            <Table
              currentPage={currentPage}
              totalData={error ? 0 : data.data.total}
              head={columns}
              body={error ? [] : formattedData(data.data.data)}
              setCurrentPage={setCurrentPage}
              enableSearch={false}
              elements={{
                action: actionSorrundWithButton,
              }}
            />
          </>
        )}
      </DCard>
    </div>
  );
};

export default BalanceHistory;
